<script setup>
defineProps({
  option: {
    type: Object,
    default: () => {},
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['option-selected']);
</script>

<template>
  <div
    class="radioListItem option border-2 h-20 mb-4 rounded rounded-xl last:mb-0 flex px-6"
    :class="{
      'border-darkOcean-600': isSelected,
      'border-neutral-300': !isSelected,
      'bg-darkOcean-100': isSelected,
    }"
    @click="emit('option-selected')"
  >
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center">
        <div
          class="mr-4 rounded rounded-full h-12 w-12 flex items-center justify-center"
          :style="{ backgroundColor: option.color }"
        >
          <fa-icon class="text-2xl text-white" :icon="['fas', 'home']" />
        </div>

        <p class="h600">
          {{ option.name }}
        </p>
      </div>

      <div
        v-if="isSelected"
        class="rounded-full w-6 h-6 flex items-center justify-center bg-darkOcean-600"
      >
        <div class="rounded-full w-[10px] h-[10px] bg-white" />
      </div>

      <div
        v-else
        class="rounded-full w-6 h-6 bg-white border border-darkOcean-600"
      />
    </div>
  </div>
</template>
